<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h2>Relatório de Acesso</h2>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start start">
          <mat-form-field color="accent" appearance="outline" fxFlex="20">
            <mat-label>Data inicial</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              placeholder="Data Inicial"
              id="startLastAccess"
              readonly
              formControlName="startLastAccess"
              (dateChange)="onChangeStartDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker color="primary"></mat-datepicker>
          </mat-form-field>

          <mat-form-field color="accent" appearance="outline" fxFlex="20">
            <mat-label>Data Final</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              [min]="minEndLastAccess"
              placeholder="Data Final"
              id="endLastAccess"
              readonly
              formControlName="endLastAccess"
              (dateChange)="onChangeEndDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker color="warn"></mat-datepicker>
          </mat-form-field>
          <mat-icon
            *ngIf="
              form.get('startLastAccess').value ||
              form.get('endLastAccess').value
            "
            class="icons"
            matTooltip="Limpar Período"
            matTooltipPosition="right"
            (click)="clearPeriod()"
            >clear</mat-icon
          >
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-md="column"
          fxLayoutAlign="end center"
          class="btn__register__container"
        >
          <button
            mat-raised-button
            type="submit"
            color="primary"
            (click)="onSubmit()"
          >
            Gerar Relatório
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
